import React, { Component } from 'react';

import './TimeBar.scss';

export class TimeBar extends Component {
  static hourHeight = 39.0;

  constructor(props, state) {
    super(props, state);

    this.state = {
      top: this.getOffset(),
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({
        top: this.getOffset(),
      });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getOffset = () => {
    let date = new Date();
    let hourOffset = date.getHours() * TimeBar.hourHeight;
    let minutesOffset = (TimeBar.hourHeight * date.getMinutes()) / 60;
    return hourOffset + minutesOffset;
  };

  render() {
    return <div className="time-bar" style={{ top: this.state.top + 'px' }} />;
  }
}
